"use client"

import { MenuDivider, MenuItem, MenuLabel } from "@mantine/core"
import { IconSnowflake, IconSnowflakeOff } from "@tabler/icons-react"
import { useSnowStore } from "@/stores/snow.zustand"

function isSnowSeason(): boolean {
  const now = new Date()
  const month = now.getMonth()
  const day = now.getDate()
  return (month === 11 && day >= 24) || (month === 0 && day <= 7)
}

export function MenuExtraSection() {
  const { snowEnabled, setSnowEnabled } = useSnowStore()

  if (!isSnowSeason()) {
    return null
  }

  return (
    <>
      <MenuDivider />
      <MenuLabel>Extra</MenuLabel>
      <MenuItem leftSection={snowEnabled ? <IconSnowflakeOff size={16} /> : <IconSnowflake size={16} />} onClick={() => setSnowEnabled(!snowEnabled)}>
        {snowEnabled ? "Stop the snow!" : "Let it snow"}
      </MenuItem>
    </>
  )
}
